import { trackEvent } from './trackEvent';

/** Playback failed after APIs succeeded — blank screen, video error, or load timeout. */
export function trackCctvStreamLoadFailed({ playerMode, message, endpoint, method } = {}) {
    trackEvent({
        category: 'cctv',
        title: 'Stream failed to load',
        message: message || 'Stream did not start — blank screen',
        endpoint: endpoint || 'cctv-stream',
        method,
        playerMode,
    });
}
